import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=1365aad2&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=ts"
export * from "./StackedBarChart.vue?vue&type=script&lang=ts"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=1365aad2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1365aad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1365aad2')) {
      api.createRecord('1365aad2', component.options)
    } else {
      api.reload('1365aad2', component.options)
    }
    module.hot.accept("./StackedBarChart.vue?vue&type=template&id=1365aad2&scoped=true", function () {
      api.rerender('1365aad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StackedBarChart.vue"
export default component.exports